import { formatDate, DATETIME_FORMATS } from '@myap/ui-library/esm/date'
import { selectApprovalRequestExamWindowRefData } from '../../selectors/examWindows'
import { SEE_SUBMISSION_DEADLINE_MSG } from '../../constants/MessageConstants'
import examDateStyles from '../../assets/style/scss/exam-date.scss'
import { EXCEPTION_TEST_ADMIN } from '../../constants/ApprovalRequestConstants'

const mapStateToProps = (state, { educationPeriodCd }) => ({
  examWindowRefData: selectApprovalRequestExamWindowRefData(state, educationPeriodCd),
})

export default connect(mapStateToProps)(
  ({ data, justExamDateType = false, inline = false, examWindowRefData = {} }) => {
    const { noEndOfCourseExam, testDate, testDayType, examDateType, examDate } = data
    const testWindow = testDayType || examDateType
    const {
      displayName = '',
      requiresUnlocking = false,
      testAdmin,
    } = examWindowRefData[testWindow] ?? {}
    const date = testDate || examDate
    const inlineStyle = inline ? { display: 'inline' } : {}

    return (
      <div className={`${examDateStyles['exam-date-wrapper']}`} style={inlineStyle}>
        {noEndOfCourseExam ? (
          SEE_SUBMISSION_DEADLINE_MSG
        ) : (
          <>
            <span className={examDateStyles['exam-type']}>
              {displayName}
              {testAdmin === EXCEPTION_TEST_ADMIN ? ' Testing' : ''}
            </span>
            {!justExamDateType && !requiresUnlocking ? (
              <span className={examDateStyles['exam-date']}>
                {formatDate(date, DATETIME_FORMATS.shortMonthDay)}
              </span>
            ) : null}
          </>
        )}
      </div>
    )
  }
)
